import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';
import { IPortalLinkedTask } from '@interfaces/portal/tasks';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	status: string | null;
	assignees: string[] | null;
	milestoneId: string | null;
	priority: string | null;
	projectId: string | null;
	linkedTasks: IPortalLinkedTask[];
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	pageSize: 5,
	status: null,
	assignees: null,
	milestoneId: null,
	priority: null,
	projectId: null,
	linkedTasks: [],
};

const portalTasks = createSlice({
	name: 'portalTasks',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStatus: (state, action: PayloadAction<{ status: string | null }>) => {
			state.status = action.payload.status;
			state.page = initialState.page;
		},
		setAssignees: (state, action: PayloadAction<{ assignees: string[] | null }>) => {
			state.assignees = action.payload.assignees;
			state.page = initialState.page;
		},
		setMilestoneId: (state, action: PayloadAction<{ milestoneId: string | null }>) => {
			state.milestoneId = action.payload.milestoneId;
			state.page = initialState.page;
		},
		setPriority: (state, action: PayloadAction<{ priority: string | null }>) => {
			state.priority = action.payload.priority;
			state.page = initialState.page;
		},
		setLinkedTasks: (state, action: PayloadAction<{ linkedTasks: IPortalLinkedTask[] }>) => {
			state.linkedTasks = [...state.linkedTasks, ...action.payload.linkedTasks];
		},
		setLinkedTask: (state, action: PayloadAction<{ linkedTask: IPortalLinkedTask }>) => {
			state.linkedTasks = [...state.linkedTasks, action.payload.linkedTask];
		},
		removeLinkedTask: (state, action: PayloadAction<{ id: string; type: string }>) => {
			state.linkedTasks = state.linkedTasks.filter((task: IPortalLinkedTask) => {
				return !(task.id === action.payload.id && task.type.name === action.payload.type);
			});
		},
		clearLinkedTasks: (state) => {
			state.linkedTasks = initialState.linkedTasks;
		},
		resetPortalTasks: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setStatus,
	setAssignees,
	setMilestoneId,
	setPriority,
	setLinkedTasks,
	setLinkedTask,
	removeLinkedTask,
	clearLinkedTasks,
	resetPortalTasks,
} = portalTasks.actions;

export default portalTasks.reducer;
